var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification-alert"},_vm._l((_vm.notifications),function(notification,index){return _c('v-alert',{key:index,attrs:{"dense":"","text":"","type":notification.type}},[_vm._v(" "+_vm._s(notification.message)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }